import React, { Fragment, useEffect, useState } from "react";
import DefaultInput from "../../../components/inputs/defaultInput";
import DefaultButton from "../../../components/buttons/defaultButton";
import { useNavigate, useParams } from "react-router-dom";
import {
  getStaffDetail,
  updateStaff,
} from "../../../../services/workspace/staff.service";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import DefaultDatePicker from "../../../components/inputs/defaultDatePicker";
import moment from "moment";
import { dateFormat } from "../../../../utils/helper";
import Loading from "../../../components/skeleton/loading";
import DefaultSearchSelectInput from "../../../components/inputs/defaultSearchSelectInput";
import {
  __License_type,
  _GenderData,
  _Marital_status,
  _transformPayload,
  convertToLabelValue,
} from "../../../../utils/common";
import DefaultTextarea from "../../../components/inputs/defaultTextarea";
import CheckboxInput from "../../../components/inputs/checkboxInput";
import { useDispatch, useSelector } from "react-redux";
import {
  _fetchDepartments,
  _fetchDesignations,
} from "../../../../store/actions/configuration";
import AddDepartmentForm from "../configuration/addDepartmentForm";
import AddDesignationForm from "../configuration/addDesignationForm";
import CommonModal from "../../../components/modals/commonModel";
import DragAndDropFile from "../../../components/inputs/simpleFileUploader";
import { CiEdit } from "react-icons/ci";
import { _setFiles } from "../../../../store/slices/global.slice";
import { IoMdAdd } from "react-icons/io";
import { MdOutlineVerified, MdVerified } from "react-icons/md";
import VerifyEmailForm from "../configuration/verifyOTPForm";
import { userVerification } from "../../../../services/workspace/user.service";

const validationSchema = Yup.object().shape({
  first_name: Yup.string().trim().required("First Name is required"),
  last_name: Yup.string().trim().required("Last Name is required"),
  father_name: Yup.string().trim().required("Father Name is required"),
  mother_name: Yup.string().trim().required("Mother Name is required"),
  marital_status: Yup.object()
    .required("Marital status is required.")
    .nullable()
    .test("isValid", "Marital status is required.", (value) => {
      return value && value.value && value.label;
    }),
  partner_name: Yup.string().when("marital_status", {
    is: (value) => value && value.value === "married", // Check if marital_status has a valid value
    then: (schema) => schema.required("Partner Name is required."),
    otherwise: (schema) => schema.notRequired(),
  }),
  date_of_marriage: Yup.string()
    .trim()
    .when("marital_status", {
      is: (value) => value && value.value === "married",
      then: (schema) =>
        schema
          .required("Date of marriage is required.")
          .test(
            "isValid",
            "Invalid date format, expected DD/MM/YYYY",
            (value) => moment(value, "YYYY-MM-DD", true).isValid()
          )
          .test(
            "notSameAsDOB",
            "Date of marriage cannot be the same as date of birth.",
            function (value) {
              const { date_of_birth } = this.parent;
              return (
                moment(value, "YYYY-MM-DD").isSame(
                  moment(date_of_birth, "YYYY-MM-DD"),
                  "day"
                ) === false
              );
            }
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
  is_teacher: Yup.string().trim().required("Teacher employee is required"),
  email: Yup.string()
    .email("Invalid email address")
    .trim()
    .required("Email is required"),
  phone: Yup.string()
    .trim()
    .required("Mobile number is required")
    .matches(/^\d+$/, "Mobile number must contain only digits")
    .min(10, "Mobile number must be at least 10 digits")
    .max(15, "Mobile number must not be greater than 15 digits"),
  gender: Yup.object()
    .required("Gender is required.")
    .nullable()
    .test("isValid", "Gender is required.", (value) => {
      return value && value.value && value.label;
    }),
  date_of_birth: Yup.string()
    .trim()
    .required("Date of birth is required")
    .test("isValid", "Invalid date format, expected DD/MM/YYYY", (value) =>
      moment(value, "YYYY-MM-DD", true).isValid()
    )
    .test("minAge", "You must be at least 18 years old.", function (value) {
      const birthDate = moment(value, "YYYY-MM-DD");
      const minAgeDate = moment().subtract(18, "years");
      return birthDate.isBefore(minAgeDate);
    }),
  date_of_join: Yup.string()
    .trim()
    .required("Date of Joining is required")
    .test("isValid", "Invalid date format, expected DD/MM/YYYY", (value) =>
      moment(value, "YYYY-MM-DD", true).isValid()
    ),

  department_id: Yup.object()
    .required("Department is required.")
    .nullable()
    .test("isValid", "Department is required.", (value) => {
      return value && value.value && value.label;
    }),
  designation_id: Yup.object().when("department_id", {
    is: (department_id) => department_id && department_id.value, // condition: when department_id is present
    then: (schema) =>
      schema
        .required("Designation is required.")
        .test("isValid", "Designation is required.", (value) => {
          return value && value.value && value.label;
        }),
    otherwise: (schema) => schema.notRequired(),
  }),
  address: Yup.string().trim().required("Address is required"),
  parmanent_address: Yup.string()
    .trim()
    .required("Permanent address is required"),
  documents: Yup.array(),
  profile_image: Yup.string(),
});

const ModalNames = {
  DESIGNATION: "DESIGNATION",
  DEPARTMENT: "DEPARTMENT",
};

export function EditStaffProfile() {
  const navigate = useNavigate();
  // const { id } = useParams();
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const user = userInfo?.user || { name: "User" };
  const id = user?.user_info?.uuid;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const { departments } = useSelector((state) => state.basicSetup);
  const [isAddressSame, setIsAddressSame] = useState(false);
  const dispatch = useDispatch();
  const [designations, setDesignations] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [showLicense, setShowLicense] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [emailVerificationLoading, setEmailVerificationLoading] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  

  const fetchDetail = () => {
    setLoading(true);
    getStaffDetail(id)
      .then((response) => {
        setLoading(false);
        setData(response);
      })
      .catch((error) => {
        toast.error("Failed to fetch the staff data!");
      });
  };

  const openModal = (modalName) => {
    setIsModalOpen(modalName);
  };

  const closeModal = () => {
    setIsModalOpen(null);
  };

  useEffect(() => {
    // dispatch(_fetchDesignations());
    // dispatch(_fetchDepartments());
    if (!id) return;
    fetchDetail();
  }, [id]);

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    touched,
    errors,
  } = useFormik({
    initialValues: {
      profile_image: data?.user?.profile_image || "",
      documents: [],
      first_name: data?.first_name || "",
      last_name: data?.last_name || "",
      father_name: data?.father_name || "",
      mother_name: data?.mother_name || "",
      partner_name: data?.partner_name || "",
      marital_status: data?.marital_status
        ? _Marital_status.find(
            (item) =>
              item.value.toLowerCase() === data.marital_status.toLowerCase()
          ) || ""
        : "",
      date_of_marriage: dateFormat(data?.date_of_marriage) || "",
      is_teacher: data?.is_teacher || 0,
      email: data?.email || "",
      phone: data?.phone || "",
      gender: data?.gender
        ? _GenderData.find((item) => item.value == data?.gender)
        : "",
      date_of_birth: dateFormat(data?.date_of_birth) || "",
      date_of_join: dateFormat(data?.date_of_join) || "",
      designation_id: data?.designation
        ? {
            label: data.designation.label || data.designation.name,
            value: data.designation.id,
          }
        : "",
      department_id: data?.designation?.department
        ? {
            label: data.designation.department.name,
            value: data.designation.department.id,
          }
        : "",
      address: data?.address || "",
      parmanent_address: data?.parmanent_address || "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    license_type: data?.license_type
      ? __License_type.find(
          (item) => item.value.toLowerCase() === data.license_type.toLowerCase()
        ) || ""
      : "",
    license_number: data?.license_number || "",
    license_expiry_date: dateFormat(data?.license_expiry_date) || "",
    onSubmit: (values) => {

      if(!isEmailVerified && values.email !== data?.email){
        verifyEmail();
        return;
      }
      setIsSubmitting(true);
      const formatData = _transformPayload(values);
      const profile_image =
        formatData?.documents && formatData?.documents[0]
          ? formatData.documents[0]
          : null;
      const payload = { ...formatData, profile_image };
      if (id)
        updateStaff(payload, id)
          .then((response) => {
            toast.success("Staff updated successfully!");
            navigate("/profile");
          })
          .catch((error) => {
            setIsSubmitting(false);
            toast.error(
              "Failed to update staff!" + error.response.data?.message
            );
          });
    },
  });

  useEffect(() => {
    if (isAddressSame) {
      const value = values.address;
      setFieldValue("parmanent_address", value);
    } else {
      setFieldValue("parmanent_address", "");
    }
  }, [isAddressSame]);

  const hendalAddressSame = () => {
    setIsAddressSame(!isAddressSame);
  };

  useEffect(() => {
    return () => {
      dispatch(_setFiles([]));
    };
  }, []);

  useEffect(() => {
    if (values?.department_id?.value) {
      // Find designations based on department_id and format the data
      let designationsData = [];
      const selectedDepartment = id
        ? departments.find((item) => item?.id == values.department_id?.value)
        : values?.department_id;
      if (selectedDepartment?.designations) {
        designationsData = convertToLabelValue(selectedDepartment.designations);
      }
      if (data?.designation?.department_id !== values.department_id?.value) {
        setFieldValue("designation_id", ""); // Clear designation_id if department changed
      }
      // Update designations state
      setDesignations([...designationsData]);
      setShowLicense(false);
    }
  }, [values.department_id]);

  useEffect(() => {
    if (
      values.designation_id &&
      values.designation_id?.roles &&
      values.designation_id?.roles?.length
    ) {
      if (
        values.designation_id?.roles[0]?.key === "driver" ||
        values.designation_id?.roles[0]?.key === "helper"
      ) {
        setShowLicense(true);
      } else {
        setShowLicense(false);
      }
    }
  }, [values.designation_id]);

  const [countdown, setCountdown] = useState(0);
  const [resendDisabled, setResendDisabled] = useState(false);
  const startResendTimer = () => {
    setResendDisabled(true);
    setCountdown(60); // 1 minute in seconds
  };

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    } else if (countdown === 0 && resendDisabled) {
      setResendDisabled(false);
    }
    
    return () => {
      clearTimeout(timer);
    };
  }, [countdown, resendDisabled]);

  const verifyEmail = () => {

    // setIsEmailVerified(!isEmailVerified);
    if (!isEmailVerified) {
      sendEmailVerification();
      openModal("VERIFY_EMAIL");
    }
  };
  

  const sendEmailVerification = () => {
    const payload = {
      email: values.email,
      type: "email",
    };
    if(resendDisabled){
      return;
    }
    setEmailVerificationLoading(true);
    userVerification(payload)
      .then((response) => {
        startResendTimer();
      })
      .catch((error) => {
      }).finally(() => {
        setEmailVerificationLoading(false);
      });
  };

  return (
    <div className={"flex flex-col gap-2"}>
      {loading ? (
        <Loading />
      ) : (
        <div className={"bg-white p-4 flex flex-col gap-4"}>
          <form onSubmit={handleSubmit} className="flex flex-col gap-2 gap-y-5">
            <div className="flex flex-col gap-2 gap-y-2">
              <h3 className="text-lg font-semibold">Personal Details</h3>
              <div className={"flex flex-col gap-3 gap-y-2 md:gap-2"}>
                <div
                  className={"grid grid-cols-1 md:grid-cols-4 gap-4 gap-y-2"}
                >
                  <DefaultInput
                    required
                    label={"First Name"}
                    placeholder={"First Name"}
                    name="first_name"
                    value={values.first_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.first_name && errors.first_name
                        ? errors.first_name
                        : ""
                    }
                    readOnly={true}
                  />
                  <DefaultInput
                    required
                    label={"Last Name"}
                    placeholder={"Last Name"}
                    name="last_name"
                    value={values.last_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.last_name && errors.last_name
                        ? errors.last_name
                        : ""
                    }
                    readOnly={true}
                  />
                  <div className="flex items-center justify-between gap-2">
                    <DefaultInput
                      required
                      label={"Email Address"}
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.email && errors.email ? errors.email : ""}
                      iconBtn={
                        isEmailVerified ? (
                          <MdVerified color="green" className="text-xl"/>
                        ) : (
                          <MdOutlineVerified className="text-xl"/>
                        )
                      }
                      disabledIconBtn={isEmailVerified || values.email === "" || values.email === data?.email}
                      iconBtnClick={() => {
                        verifyEmail();
                      }}
                      readOnly={isEmailVerified}
                    />
                  </div>
                  <DefaultInput
                    required
                    label={"Date of Joining"}
                    name="date_of_join"
                    onChange={(data) => setFieldValue("date_of_join", data)}
                    value={values.date_of_join}
                    placeholder={"YYYY-MM-DD"}
                    onBlur={handleBlur}
                    error={
                      touched.date_of_join && errors.date_of_join
                        ? errors.date_of_join
                        : ""
                    }
                    readOnly={true}
                  />
                  <DefaultInput
                    required
                    label={"Mobile Number"}
                    type={"number"}
                    name="phone"
                    value={values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.phone && errors.phone ? errors.phone : ""}
                    readOnly={true}
                  />
                  <DefaultSearchSelectInput
                    required={true}
                    label={"Department"}
                    name="department_id"
                    value={values.department_id}
                    options={departments}
                    onChange={(e) => {
                      setFieldValue("department_id", e);
                    }}
                    onBlur={handleBlur}
                    error={
                      touched.department_id && errors.department_id
                        ? errors.department_id
                        : ""
                    }
                    // addmoreClick={() => openModal(ModalNames.DEPARTMENT)}
                    isDisabled={true}
                  />
                  <DefaultSearchSelectInput
                    required={true}
                    label={"Designation"}
                    name="designation_id"
                    value={values.designation_id}
                    options={designations}
                    onChange={(e) => {
                      setFieldValue("designation_id", e);
                    }}
                    onBlur={handleBlur}
                    error={
                      touched.designation_id && errors.designation_id
                        ? errors.designation_id
                        : ""
                    }
                    // addmoreClick={() => openModal(ModalNames.DESIGNATION)}
                    isDisabled={true}
                  />
                </div>
                <div
                  className={"grid grid-cols-1 md:grid-cols-4 gap-4 gap-y-2"}
                >
                  {showLicense ? (
                    <Fragment>
                      {" "}
                      <DefaultSearchSelectInput
                        label={"License type"}
                        name="license_type"
                        value={values.license_type}
                        options={__License_type}
                        onChange={(e) => {
                          setFieldValue("license_type", e);
                        }}
                        onBlur={handleBlur}
                        error={
                          touched.license_type && errors.license_type
                            ? errors.license_type
                            : ""
                        }
                        readOnly={true}
                      />
                      <DefaultInput
                        label={"License number"}
                        name="license_number"
                        value={values.license_number}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.license_number && errors.license_number
                            ? errors.license_number
                            : ""
                        }
                        readOnly={true}
                      />
                      <DefaultDatePicker
                        label={"License expiry date"}
                        name="license_expiry_date"
                        onChange={(data) =>
                          setFieldValue("license_expiry_date", data)
                        }
                        value={values.license_expiry_date}
                        placeholder={"YYYY-MM-DD"}
                        onBlur={handleBlur}
                        error={
                          touched.license_expiry_date &&
                          errors.license_expiry_date
                            ? errors.license_expiry_date
                            : ""
                        }
                        readOnly={true}
                      />
                    </Fragment>
                  ) : (
                    ""
                  )}
                </div>

                <div
                  className={"grid grid-cols-1 md:grid-cols-4 gap-4 gap-y-2"}
                >
                  <DefaultInput
                    required
                    label={"Date of birth"}
                    name="date_of_birth"
                    onChange={(data) => setFieldValue("date_of_birth", data)}
                    value={values.date_of_birth}
                    placeholder={"YYYY-MM-DD"}
                    onBlur={handleBlur}
                    error={
                      touched.date_of_birth && errors.date_of_birth
                        ? errors.date_of_birth
                        : ""
                    }
                    readOnly={true}
                  />
                  <DefaultSearchSelectInput
                    required
                    label={"Marital Status"}
                    name="marital_status"
                    value={values.marital_status}
                    options={_Marital_status}
                    onChange={(e) => {
                      setFieldValue("marital_status", e);
                    }}
                    onBlur={handleBlur}
                    error={
                      touched.marital_status && errors.marital_status
                        ? errors.marital_status
                        : ""
                    }
                  />

                  <DefaultSearchSelectInput
                    required
                    label={"Gender"}
                    name="gender"
                    value={values.gender}
                    options={_GenderData}
                    onChange={(e) => {
                      setFieldValue("gender", e);
                    }}
                    onBlur={handleBlur}
                    error={touched.gender && errors.gender ? errors.gender : ""}
                    isDisabled={true}
                  />
                  {values.marital_status &&
                    values.marital_status?.value == "married" && (
                      <Fragment>
                        <DefaultDatePicker
                          required
                          label={"Date of marriage"}
                          name="date_of_marriage"
                          onChange={(data) =>
                            setFieldValue("date_of_marriage", data)
                          }
                          value={values.date_of_marriage}
                          placeholder={"YYYY-MM-DD"}
                          onBlur={handleBlur}
                          error={
                            touched.date_of_marriage && errors.date_of_marriage
                              ? errors.date_of_marriage
                              : ""
                          }
                        />
                        <DefaultInput
                          required
                          label={"Partner name"}
                          name="partner_name"
                          value={values.partner_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={
                            touched.partner_name && errors.partner_name
                              ? errors.partner_name
                              : ""
                          }
                        />
                      </Fragment>
                    )}
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-2 gap-y-2">
              <h2 className="text-lg font-semibold">Parent/Guardian Details</h2>
              <div className={"flex flex-col gap-3 gap-y-2 md:gap-2"}>
                <div
                  className={"grid grid-cols-1 md:grid-cols-2 gap-4 gap-y-2"}
                >
                  <DefaultInput
                    required
                    label={"Father Name"}
                    name="father_name"
                    value={values.father_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.father_name && errors.father_name
                        ? errors.father_name
                        : ""
                    }
                  />
                  <DefaultInput
                    required
                    label={"Mother Name"}
                    name="mother_name"
                    value={values.mother_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.mother_name && errors.mother_name
                        ? errors.mother_name
                        : ""
                    }
                  />
                  <div className="col-span-2">
                    <DefaultTextarea
                      required
                      label={"Current Address"}
                      placeholder={"Current address"}
                      name="address"
                      value={values.address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.address && errors.address ? errors.address : ""
                      }
                    />
                  </div>
                  <div className="col-span-2">
                    <CheckboxInput
                      data={[
                        {
                          id: "1",
                          name: "Permanent address same as Current address",
                        },
                      ]}
                      checked={isAddressSame}
                      onChange={hendalAddressSame}
                    />
                  </div>
                  <div className="col-span-2">
                    <DefaultTextarea
                      required
                      label={"Permanent address"}
                      placeholder={"Permanent address"}
                      name="parmanent_address"
                      value={values.parmanent_address}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        touched.parmanent_address && errors.parmanent_address
                          ? errors.parmanent_address
                          : ""
                      }
                    />
                  </div>
                  <div>
                    <DefaultButton
                      variant="default"
                      name={"Submit"}
                      type="submit"
                      loading={isSubmitting}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          {isModalOpen === "VERIFY_EMAIL" && (
            <CommonModal
              modalSize="lg"
              headerTitle="Enter OTP"
              onClose={closeModal}
              show={isModalOpen === "VERIFY_EMAIL"}
            >
              <VerifyEmailForm isModal={true} closeModal={closeModal} isSubmitting={emailVerificationLoading} 
              setIsSubmitting={setEmailVerificationLoading}
              sendEmailVerification={sendEmailVerification}
              countdown={countdown}
              resendDisabled={resendDisabled}
              setIsEmailVerified={setIsEmailVerified}
              email={values.email}
              />
            </CommonModal>
          )}

          
          {isModalOpen === ModalNames.DESIGNATION && (
            <CommonModal
              modalSize="lg"
              headerTitle="Designation"
              onClose={closeModal}
              show={isModalOpen === ModalNames.DESIGNATION}
            >
              <AddDesignationForm isModal={true} closeModal={closeModal} />
            </CommonModal>
          )}

          {isModalOpen === ModalNames.DEPARTMENT && (
            <CommonModal
              modalSize="lg"
              headerTitle="Department"
              onClose={closeModal}
              show={isModalOpen === ModalNames.DEPARTMENT}
            >
              <AddDepartmentForm isModal={true} closeModal={closeModal} />
            </CommonModal>
          )}
        </div>
      )}
    </div>
  );
}
